var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 561.13 575.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #32619d;\n      }\n\n      .cls-3 {\n        fill: #c5d2e3;\n      }\n\n      .cls-4 {\n        fill: #4771a7;\n      }\n\n      .cls-5 {\n        fill: #b0c2d9;\n      }\n\n      .cls-6 {\n        fill: #bed0e8;\n      }\n\n      .cls-7 {\n        opacity: .12;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: #3e6aa3;\n      }\n\n      .cls-8 {\n        opacity: .3;\n      }\n\n      .cls-9 {\n        opacity: .22;\n      }\n\n      .cls-11 {\n        fill: #a4b9d3;\n      }\n\n      .cls-12 {\n        fill: #cbd7e6;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: #305f9c;\n      }\n\n      .cls-16 {\n        fill: #688ab7;\n      }\n\n      .cls-17 {\n        opacity: .7;\n      }\n\n      .cls-18 {\n        fill: #98afce;\n      }\n\n      .cls-19 {\n        fill: #a0b5d1;\n      }\n\n      .cls-20 {\n        fill: #8ba5c8;\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-22 {\n        fill: #b7c7dc;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 561.13,
    height: 575.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.73-.63c2.84,2.08,4.07-9.53,2.28,6.89-1.79,16.42-7.91,32.9-19.32,42.66-13.19,11.28-31.87,12.54-43.13,26.39-16.09,19.79-9.23,55.24-25.14,75.24-9.23,11.61-24.39,15.4-32.47,28.13-12.15,19.14-3.61,50.76-18.84,66.59-7.3,7.58-17.84,8.79-26.54,13.95-8.7,5.16-34.56,16.09-34.54,45.41h0l-73.78-19.42c1.38-10.16-6.45-18.85-14.39-23.19-7.94-4.34-17.04-6.71-23.21-14.01-8.19-9.7-8.68-24.86-8.92-38.51-.24-13.65-1.42-28.98-10.31-37.78-8.73-8.64-22.03-7.88-31.26-15.79-10.33-8.86-12.54-25.57-14.14-40.48-1.6-14.91-4.45-31.69-15.31-39.63-8.1-5.93-18.48-5.14-27.46-8.98-10.47-4.47-18.38-15.08-23.24-26.85-4.86-11.77-9.25-31.94-11.41-44.77L494.73-.63Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 306.87,
    cy: 536.64,
    rx: 181.78,
    ry: 5.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "215.23 277.26 235.36 335.9 328.25 335.9 325.56 327.79 308.95 327.21 295.19 277.26 215.23 277.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "221.1 282.09 236.57 327.21 303.95 324.34 292.54 282.09 221.1 282.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.79,
    y: 335.9,
    width: 338.66,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 402.99,
    y: 344.33,
    width: 6.94,
    height: 185.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 434.88,
    y: 344.33,
    width: 6.94,
    height: 185.19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M363.67,519.79s-25.96,13.16-25.96,17.25c0,1.82,52.18,0,52.93,0s-4.49-17.25-4.49-17.25h-22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M390.95,534.01s-.18.06-.52.12c-.4.07-.91.15-1.52.26-.66.11-1.47.23-2.41.33-.94.1-2.02.24-3.21.31-2.38.2-5.22.3-8.38.33-3.16.02-6.62-.05-10.26-.15-3.64-.1-7.1-.18-10.25-.21-3.15,0-5.98.04-8.36.17-1.19.04-2.26.14-3.2.21-.94.06-1.75.14-2.42.22-.61.06-1.12.11-1.53.15-.35.03-.54.03-.54.02,0-.02.18-.06.52-.12.41-.06.91-.15,1.52-.24.66-.11,1.47-.22,2.41-.31.94-.09,2.02-.22,3.21-.28,2.38-.18,5.23-.26,8.38-.28,3.16,0,6.62.07,10.26.17,3.64.1,7.1.18,10.24.19,3.15,0,5.98-.07,8.36-.22,1.19-.04,2.26-.16,3.2-.23.94-.06,1.75-.16,2.41-.24.61-.06,1.12-.12,1.53-.16.35-.03.54-.04.54-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M356.36,530.92c-.14.05-.65-1.25-1.5-2.73-.83-1.48-1.71-2.57-1.59-2.67.09-.1,1.18.87,2.05,2.41.88,1.54,1.18,2.95,1.04,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M359.39,529.52c-.15.04-.58-1.4-1.43-3.02-.84-1.62-1.81-2.77-1.7-2.87.09-.1,1.28.93,2.16,2.63.89,1.69,1.1,3.24.97,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M362.79,528.04c-.15.03-.51-1.51-1.26-3.28-.74-1.78-1.62-3.08-1.49-3.18.1-.09,1.2,1.13,1.97,2.97.78,1.84.92,3.46.78,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M360.1,522.34c-.06.04-.84-1-2.06-2.71-.63-.9-1.34-1.92-2.11-3.03-.39-.57-.82-1.16-1.22-1.82-.2-.33-.39-.68-.55-1.05-.15-.36-.33-.8-.22-1.32.06-.26.3-.55.64-.57.33-.01.54.14.72.27.35.3.57.58.83.87.5.59.93,1.18,1.31,1.78.76,1.19,1.29,2.34,1.66,3.34.37.99.58,1.83.69,2.41.12.58.14.91.11.91-.09.02-.34-1.26-1.14-3.19-.4-.96-.96-2.07-1.72-3.21-.38-.57-.81-1.15-1.3-1.71-.24-.27-.51-.59-.76-.8-.3-.22-.46-.21-.53.03-.07.28.04.64.19.98.15.35.32.68.51.99.38.63.8,1.23,1.18,1.82.74,1.13,1.42,2.17,2.02,3.09,1.14,1.77,1.81,2.88,1.75,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M360.12,522.64s-.13-.26-.25-.77c-.12-.5-.27-1.24-.37-2.17-.1-.92-.17-2.03-.13-3.27.02-.62.07-1.26.14-1.93.04-.33.09-.67.14-1.01.06-.33.08-.74.41-1.11.15-.16.43-.32.74-.23.29.1.42.32.51.5.16.37.22.69.31,1.03.15.67.21,1.33.21,1.95,0,1.25-.24,2.37-.56,3.25-.32.89-.72,1.54-1.03,1.96-.31.42-.53.61-.56.59-.08-.06.7-.93,1.24-2.67.27-.86.46-1.94.43-3.13-.01-.59-.08-1.22-.22-1.85-.08-.3-.16-.65-.27-.91-.16-.27-.22-.29-.4-.13-.16.16-.22.5-.27.83-.06.33-.1.67-.15.99-.08.65-.14,1.28-.17,1.89-.07,1.21-.04,2.3.01,3.21.12,1.83.34,2.95.26,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M378.22,535.1c-.06,0-.16-.89.04-2.32.2-1.42.74-3.39,1.97-5.25,1.21-1.87,2.86-3.13,4.16-3.77,1.31-.64,2.22-.74,2.22-.68.03.09-.84.31-2.05,1.01-1.21.69-2.74,1.94-3.9,3.73-1.17,1.78-1.76,3.66-2.04,5.03-.29,1.38-.32,2.26-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M353.94,535.24c-.08-.01-.02-.53-.14-1.34-.12-.8-.47-1.89-1.16-2.91-.69-1.03-1.54-1.8-2.15-2.37-.62-.56-.99-.93-.95-.98.04-.05.5.2,1.18.7.68.5,1.61,1.26,2.35,2.36.75,1.1,1.07,2.3,1.09,3.17.03.87-.17,1.39-.23,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M370.04,532.84c0,.14-1.83.14-4.06-.01-2.23-.15-4.03-.39-4.02-.53,0-.14,1.83-.14,4.06.01,2.23.15,4.03.39,4.02.53Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "353.93 486.14 363.67 519.79 386.14 519.79 380.93 486.14 353.93 486.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "363.67 519.79 358.8 502.97 383.37 501.91 386.14 520.33 363.67 519.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "359.76 506.27 383.86 505.21 384.15 506.77 360.13 507.54 359.76 506.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "360.49 508.63 384.35 507.57 384.64 509.13 360.85 509.9 360.49 508.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "353.93 486.14 355.32 490.92 381.87 492.22 380.93 486.14 353.93 486.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M440.19,363.26h-100.28s-23.78,3.63-17.06,32.69c6.72,29.05,28.95,90.19,28.95,90.19h32.57l-15.51-69.61,56.34-1.82,14.99-51.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M374.93,481.05c.14-.04.49.8.78,1.86.29,1.07.41,1.96.27,2s-.49-.8-.78-1.86c-.29-1.07-.41-1.96-.27-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M370.72,465.62c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M366.52,450.18c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93-.14.04-.72-1.66-1.3-3.79-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M362.31,434.74c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M358.1,419.3c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93-.14.04-.72-1.66-1.3-3.79-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.93,403.86c.14-.03.67,1.67,1.26,3.8.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.6-2.12-.91-3.91-.76-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M363.13,395.73c0,.15-1.81.17-4.01.08-1.09-.04-2.06.04-2.73.23-.67.19-1.05.43-1.1.36-.04-.05.27-.41.98-.71.7-.31,1.75-.44,2.86-.4,2.22.09,4,.3,3.99.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M379.11,396.52c0,.14-1.8.17-4.01.06-2.21-.11-3.99-.32-3.98-.46,0-.14,1.8-.17,4.01-.06,2.21.11,3.99.32,3.98.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M395.09,397.34c0,.14-1.8.17-4.01.05-2.21-.11-3.99-.32-3.98-.47,0-.14,1.8-.17,4.01-.05,2.21.11,3.99.32,3.98.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M411.07,398.15c0,.14-1.8.17-4.01.06-2.21-.11-3.99-.32-3.98-.46,0-.14,1.8-.17,4.01-.06,2.21.11,3.99.32,3.98.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M423.05,398.73c0,.14-.91.22-2.01.17-1.1-.05-1.99-.21-1.99-.35,0-.14.91-.22,2.01-.17,1.1.05,1.99.21,1.99.35Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.19,513.08c-.09-.29-.23-.61-.48-.68-.21-.06-.44.09-.57.3-.13.21-.18.47-.22.72-.44,2.55-.45,5.19-.07,7.75,1.62-2.17,2.17-5.38,1.33-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.19,363.26h-100.28s-23.78,3.63-17.06,32.69c6.72,29.05,28.95,90.19,28.95,90.19h2.13l1.38,4.78h0l3.49,12.05.96,3.31h0l.37,1.27h0l3.54,12.25s-1.42.72-3.58,1.87c-.02-.03-.03-.05-.05-.08l.04.09s-.07.04-.1.05l-.07-.31c-.01-.05-.03-.1-.04-.15,0-.03,0-.06-.01-.09,0,0,0,0,0,0-.72-3.31-2.29-6.37-4.46-8.66-.28-.3-.7-.59-1.01-.34-.3.25-.23.79-.08,1.19.33.87.85,1.64,1.35,2.39,1.37,2.02,2.74,4.05,4.11,6.07-1.02.54-2.19,1.17-3.45,1.86-.02-.02-.04-.05-.06-.07l.04.08c-7.68,4.22-18.59,10.68-18.59,13.33,0,1.82,52.18,0,52.93,0,.2,0-.02-1.18-.44-2.93.25-.04.51-.06.76-.1l-.78.03c-1.2-4.94-4.03-14.24-4.03-14.24l-1.65-10.66h.15s-.28-1.57-.28-1.57h-.11s-.12-.79-.12-.79h.03s-.19-1.05-.19-1.05l-2.09-13.51h0l-.94-6.08h3.44l-15.51-69.61,56.34-1.82,14.99-51.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M327.26,519.79s-25.96,13.16-25.96,17.25c0,1.82,52.18,0,52.93,0s-4.49-17.25-4.49-17.25h-22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M354.54,534.01s-.18.06-.52.12c-.4.07-.91.15-1.52.26-.66.11-1.47.23-2.41.33-.94.1-2.02.24-3.21.31-2.38.2-5.22.3-8.38.33-3.16.02-6.62-.05-10.26-.15-3.64-.1-7.1-.18-10.25-.21-3.15,0-5.98.04-8.36.17-1.19.04-2.26.14-3.2.21-.94.06-1.75.14-2.42.22-.61.06-1.12.11-1.53.15-.35.03-.54.03-.54.02,0-.02.18-.06.52-.12.41-.06.91-.15,1.52-.24.66-.11,1.47-.22,2.41-.31.94-.09,2.02-.22,3.21-.28,2.38-.18,5.22-.26,8.38-.28,3.16,0,6.62.07,10.26.17,3.64.1,7.1.18,10.24.19,3.15,0,5.98-.07,8.36-.22,1.19-.04,2.26-.16,3.2-.23.94-.06,1.75-.16,2.41-.24.61-.06,1.12-.12,1.53-.16.35-.03.54-.04.54-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M319.95,530.92c-.14.05-.65-1.25-1.5-2.73-.83-1.48-1.71-2.57-1.59-2.67.09-.1,1.18.87,2.05,2.41.88,1.54,1.18,2.95,1.04,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M322.98,529.52c-.15.04-.58-1.4-1.43-3.02-.84-1.62-1.81-2.77-1.7-2.87.09-.1,1.28.93,2.16,2.63.89,1.69,1.1,3.24.97,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M326.38,528.04c-.15.03-.51-1.51-1.26-3.28-.74-1.78-1.62-3.08-1.49-3.18.1-.09,1.2,1.13,1.97,2.97.78,1.84.92,3.46.78,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M323.69,522.34c-.06.04-.84-1-2.06-2.71-.63-.9-1.34-1.92-2.11-3.03-.39-.57-.82-1.16-1.22-1.82-.2-.33-.39-.68-.55-1.05-.15-.36-.33-.8-.21-1.32.06-.26.3-.55.64-.57.33-.01.54.14.72.27.35.3.57.58.83.87.5.59.93,1.18,1.31,1.78.76,1.19,1.29,2.34,1.66,3.34.37.99.58,1.83.69,2.41.12.58.14.91.11.91-.09.02-.34-1.26-1.14-3.19-.4-.96-.96-2.07-1.72-3.21-.38-.57-.81-1.15-1.3-1.71-.24-.27-.51-.59-.76-.8-.3-.22-.46-.21-.53.03-.07.28.04.64.19.98.15.35.32.68.51.99.38.63.8,1.23,1.18,1.82.74,1.13,1.42,2.17,2.02,3.09,1.14,1.77,1.81,2.88,1.75,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M323.71,522.64s-.13-.26-.25-.77c-.12-.5-.27-1.24-.37-2.17-.1-.92-.17-2.03-.13-3.27.02-.62.07-1.26.14-1.93.04-.33.09-.67.14-1.01.06-.33.08-.74.41-1.11.15-.16.43-.32.74-.23.29.1.42.32.51.5.16.37.22.69.31,1.03.15.67.21,1.33.21,1.95,0,1.25-.24,2.37-.56,3.25-.32.89-.72,1.54-1.03,1.96-.31.42-.53.61-.56.59-.08-.06.7-.93,1.24-2.67.27-.86.46-1.94.43-3.13-.01-.59-.08-1.22-.22-1.85-.08-.3-.16-.65-.27-.91-.16-.27-.22-.29-.4-.13-.16.16-.22.5-.27.83-.06.33-.1.67-.15.99-.08.65-.14,1.28-.17,1.89-.07,1.21-.04,2.3.01,3.21.12,1.83.34,2.95.26,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M341.81,535.1c-.06,0-.16-.89.04-2.32.2-1.42.75-3.39,1.97-5.25,1.21-1.87,2.86-3.13,4.16-3.77,1.31-.64,2.22-.74,2.22-.68.03.09-.84.31-2.05,1.01-1.21.69-2.74,1.94-3.9,3.73-1.17,1.78-1.76,3.66-2.04,5.03-.29,1.38-.32,2.26-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.53,535.24c-.08-.01-.02-.53-.14-1.34-.12-.8-.47-1.89-1.16-2.91-.69-1.03-1.54-1.8-2.15-2.37-.62-.56-.99-.93-.95-.98.04-.05.5.2,1.18.7.68.5,1.61,1.26,2.35,2.36.75,1.1,1.07,2.3,1.09,3.17.03.87-.17,1.39-.23,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M333.63,532.84c0,.14-1.83.14-4.06-.01-2.23-.15-4.03-.39-4.02-.53,0-.14,1.83-.14,4.06.01,2.23.15,4.03.39,4.02.53Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "317.53 486.14 327.26 519.79 349.73 519.79 344.52 486.14 317.53 486.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "327.26 519.79 322.39 502.97 346.96 501.91 349.73 520.33 327.26 519.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "323.35 506.27 347.46 505.21 347.74 506.77 323.72 507.54 323.35 506.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "324.08 508.63 347.95 507.57 348.23 509.13 324.45 509.9 324.08 508.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "317.53 486.14 318.91 490.92 345.46 492.22 344.52 486.14 317.53 486.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M403.79,363.26h-100.28s-23.78,3.63-17.06,32.69c6.72,29.05,28.95,90.19,28.95,90.19h32.57l-15.51-69.61,56.34-1.82,14.99-51.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M338.52,481.05c.14-.04.49.8.78,1.86.29,1.07.41,1.96.27,2-.14.04-.49-.8-.78-1.86-.29-1.07-.41-1.96-.27-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M334.32,465.62c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.11,450.18c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M325.9,434.74c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93-.14.04-.72-1.66-1.3-3.79-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M321.69,419.3c.14-.04.72,1.66,1.3,3.79.58,2.13.94,3.89.8,3.93-.14.04-.72-1.66-1.3-3.79-.58-2.13-.94-3.89-.8-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M317.52,403.86c.14-.03.67,1.67,1.26,3.8.58,2.13.94,3.89.8,3.93s-.72-1.66-1.3-3.79c-.6-2.12-.91-3.91-.76-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M326.72,395.73c0,.15-1.81.17-4.01.08-1.09-.04-2.06.04-2.73.23-.67.19-1.05.43-1.1.36-.04-.05.27-.41.98-.71.7-.31,1.75-.44,2.86-.4,2.22.09,4,.3,3.99.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M342.7,396.52c0,.14-1.8.17-4.01.06-2.21-.11-3.99-.32-3.98-.46,0-.14,1.8-.17,4.01-.06,2.21.11,3.99.32,3.98.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M358.68,397.34c0,.14-1.8.17-4.01.05-2.21-.11-3.99-.32-3.98-.47,0-.14,1.8-.17,4.01-.05,2.21.11,3.99.32,3.98.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M374.66,398.15c0,.14-1.8.17-4.01.06-2.21-.11-3.99-.32-3.98-.46,0-.14,1.8-.17,4.01-.06,2.21.11,3.99.32,3.98.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M386.65,398.73c0,.14-.91.22-2.01.17-1.1-.05-1.99-.21-1.99-.35,0-.14.91-.22,2.01-.17,1.1.05,1.99.21,1.99.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M295.19,312.97s42.24-1.24,51.91-5.72c35.56-16.47,51.7-44.18,56.69-45.58,4.99-1.4,13.95-2.34,16.59,5.36,2.64,7.7-9.2,32.57-24.63,45.12-3.69,3-7.12,5.67-10.3,8.04-16.28,12.15-35.21,18.54-54.52,18.54l-35.74.12v-25.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M450.54,253.46c-.13-.39-.27-.79-.45-1.18-.82-1.91-2.39-3.33-3.68-5.03-.65-.85-1.22-1.83-1.44-2.94-.22-1.11,0-2.31.45-3.46.45-1.16,1.11-2.27,1.69-3.53.57-1.26,1.04-2.63,1.33-4.09.6-2.87.5-6.22-.88-9.06-1.41-2.82-3.64-4.59-5.5-6.4-1.89-1.77-3.42-3.81-4.64-5.98-2.77-6.45-2.88-14.35-4.14-21.59-.19-1.1-.49-2.13-.87-3.12.67.5,1.34.82,1.89.96.85.21,1.39.1,1.4-.03.05-.3-2.03-.66-3.69-2.65-.02-.02-.03-.05-.05-.07.62.55,1.35,1.1,2.19,1.54,1.5.78,2.98,1.06,4.05,1.06,1.07,0,1.71-.21,1.7-.34,0-.32-2.58-.22-5.37-1.7-1.38-.7-2.49-1.61-3.28-2.34.71-.04,1.41-.14,2.08-.4,2.06-.78,3.67-3.06,3.88-5.59.22-2.53-.99-5.16-2.93-6.29-1.94-1.14-4.49-.67-6.01,1.14-1.1,1.31-1.6,3.11-1.78,4.97-3.19-3.18-7.09-3.43-10.28-3.01-2.26.3-4.43,1.82-6.38,2.36.26-.38.56-.79.88-1.24,1.07-1.49,2.02-2.65,1.87-2.89-.14-.23-1.42.6-2.57,2.2-.1.14-.19.28-.28.42-.01-.22-.03-.45-.05-.68-.15-1.77-.34-3.22-.59-3.22-.25,0-.47,1.49-.32,3.33.05.65.14,1.25.25,1.75-.7-.6-1.42-1.09-2.16-1.43-5.4-2.46-11.76-2.22-16.79,1.16-.14.09-.28.22-.42.32-1.99.86-4.08,2.23-5.91,4.3-3.27,3.72-4.69,8.49-5,11.87-.17,1.71-.13,3.1-.02,4.05.1.95.23,1.46.29,1.45.17-.02-.11-2.11.38-5.38.46-3.23,1.91-7.7,5-11.21.9-1.02,1.87-1.85,2.85-2.56-3.78,4.98-6.73,13.77-6.59,19.24,1.1-.16,2.21-.33,3.31-.49-.16,4.32-1.42,8.58-3.69,11.99-1.35,2.03-3.13,4.1-2.98,6.67.14,2.41,1.92,4.16,3.18,6.07,2.17,3.27,2.97,7.73,2.11,11.75-.15.68-.34,1.34-.56,1.98-.58,1.12-1.25,2.25-2.02,3.35-2.12,3.17-4.95,6.26-7.15,10.32-2.22,4.09-3.05,8.73-3.17,12.84-.13,4.14.4,7.83.95,10.85.57,3.02,1.19,5.42,1.62,7.07.44,1.65.72,2.54.78,2.52.06-.02-.1-.96-.44-2.63-.33-1.68-.85-4.09-1.33-7.11-.47-3.01-.92-6.64-.74-10.65.16-3.99.99-8.42,3.1-12.31.92-1.71,1.98-3.26,3.05-4.74-.81,1.26-1.58,2.55-2.23,3.92-2.87,6.02-3.28,13.31-2.29,20.1.99,6.79,1.67,11.96,3.96,18.31,0,0,72.06-21.33,72.08-21.82,2.97-3.07,3.92-8.47,2.33-12.7ZM446.78,224.72c1.23,2.54,1.35,5.59.8,8.29-.26,1.36-.69,2.65-1.23,3.84-.53,1.19-1.2,2.33-1.68,3.6-.46,1.16-.72,2.53-.51,3.81-.65-1.07-1.17-2.21-1.43-3.51-1.13-5.58,2.94-11.3,1.73-16.86-.37-1.72-1.21-3.17-2.17-4.55,1.68,1.59,3.42,3.18,4.5,5.38Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "452.83 414.71 452.83 537.85 457.65 537.85 457.65 414.02 449.77 414.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "333.38 416.5 333.19 537.85 338.2 537.85 338.2 415.23 333.38 416.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 335.79,
    y: 459.18,
    width: 121.36,
    height: 4.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M379.25,320.49s7.2,14.45,4.05,19.03c-3.15,4.58-7.2,12.93-7.2,12.93,0,0-7.49,2-8.11,8.33,0,0,.4,5.42,25.78,3.68l21.01-73.7-35.52,29.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M392.54,319.71c-3,2.88-6.43,5.53-10.26,7.5l-1.86-3.53s19.09-11.49,26.04-22.96c0,0-5.78,12.36-13.92,18.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "383.44 414.02 416.24 257.79 493.84 257.79 457.15 413.67 383.44 414.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "416.24 257.79 408.67 279.28 389.48 366.86 393.44 366.36 416.24 257.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 333.38,
    y: 408.6,
    width: 124.28,
    height: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 333.38,
    y: 417.01,
    width: 4.82,
    height: 6.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 379.15,
    y: 459.18,
    width: 9.14,
    height: 4.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "381.2 414.71 381.2 537.85 386.02 537.85 386.02 414.02 378.14 414.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M383.97,197.68l6.09-.62s-6.15,4.87-7.46,7.89c0,0,1.57-4.88,1.36-7.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 160.3,
    y: 344.33,
    width: 6.94,
    height: 185.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 202.26,
    y: 344.33,
    width: 6.94,
    height: 185.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M295.19,316.17s-21.27-2.96-22.24,19.73c0,0,1.31.87,2.46-1.22,1.14-2.08,5.85-3.12,6.1-2.23.25.89-5.85,3.45-3.94,3.45h17.62v-19.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M494.73-.63c2.03,16.38,4.07-9.53,2.28,6.89-1.79,16.42-7.91,32.9-19.32,42.66-13.19,11.28-31.87,12.54-43.13,26.39-16.09,19.79-9.23,55.24-25.14,75.24-9.23,11.61-24.39,15.4-32.47,28.13-12.15,19.14-3.61,50.76-18.84,66.59-7.3,7.58-17.84,8.79-26.54,13.95-8.7,5.16-32.43,11.22-32.41,40.54h0l-75.91-14.55c1.38-10.16-6.45-18.85-14.39-23.19-7.94-4.34-17.04-6.71-23.21-14.01-8.19-9.7-8.68-24.86-8.92-38.51-.24-13.65-1.42-28.98-10.31-37.78-8.73-8.64-22.03-7.88-31.26-15.79-10.33-8.86-12.54-25.57-14.14-40.48-1.6-14.91-4.45-31.69-15.31-39.63-8.1-5.93-18.48-5.14-27.46-8.98-10.47-4.47-18.38-15.08-23.24-26.85-4.86-11.77-6.95-31.94-9.11-44.77L494.73-.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "441.97 313.35 103.82 330.82 108.52 139.55 436.12 139.55 441.97 313.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "31.15 -10 132.13 -7.73 137.69 19.93 167.32 31.91 213.01 107.1 109.91 35.59 31.15 -10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.22,144.81c-.94.74-186.65-108.07-186.65-108.07v16.5s79.94,87.65,81.97,88.02c2.03.37,78.2,2.89,78.2,2.89l26.48.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.43-2.61L111.22,31.73l7.09,22.48,42.85,29.57,22.6,25.47,38.89,20.05,20.66,15.26-142.3-3.85S30.59,20.22,32.79,21.93c2.2,1.72,12.64-24.55,12.64-24.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "263.19 120.91 277.86 68.74 298.22 66.13 322.6 47.56 359.73 42.35 400.85 -2.63 507.78 -5.97 503.76 149.58 243.66 143.49 263.19 120.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.91,167.98c.81-.37,141.83,2.57,141.83,2.57l-32.98-17.65-108.85-32v47.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.26,73.96s8.07,24.42,8.07,22.84,2.69-9.06,2.69-9.06l3.03,16.15,3.36-9.85,2.35,9.85,3.03-21.66,4.37,30.72,6.05-6.52,1.68,13.22,6.73-13.22,5.05,19.12,2.02-22.84,4.37,22.84,5.72-12.6,2.02,12.6,8.07-19.12,2.35,27.39,6.46-5.12v9.45l3.63-9.45,5.72,14.97,4.37-7.81,4.71,11.95v-11.95l4.37,11.95,2.98-6.89,8.69,9.85,12.82,8.29s-123.23-11.44-123.23-11.25-1.49-73.85-1.49-73.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.92 159.05 312.92 124.15 354.1 89.3 375.56 36.74 511.28 -.63 531.82 165.2 294.92 159.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.74,149.58h31.26l-19.92,9.47s45.59,5.36,43.38,6.15c-2.21.8-39.39,12.72-39.39,12.72l22.13-12.72-37.46-6.15,17.98-7.04h-17.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.53,173.95c-4.98,3.1-104.99,27.15-104.99,27.15l69.3,8.53-57.38,23.27,93.07-26.37-62.79-9.31,62.79-23.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.ebbc0dde72232e56179355b3ef7ff0f8.svg";
export { ForwardRef as ReactComponent };